<template>
    <div class="process-pdf">
      <h1>Process PDF</h1>
      <input type="file" @change="uploadFile" />
    </div>
  </template>
  
  <script>

  export default {
    methods: {
      async uploadFile(event) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
  
        const response = await this.$axios.post('question/process-file', formData,
       {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
       }
     
        );
  
        const result = await response;
      },
    },
  };
  </script>

  <style scoped lang="scss">
    .process-pdf {
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      width: 10vw;
      height: 10vh;
      position: fixed;
      top: 30%;
      left: 40%;

      input {
        border: 2px solid black;
      }
    }
</style>
  